import { render, staticRenderFns } from "./FourInARow.vue?vue&type=template&id=2c93f8fa&scoped=true&"
import script from "./FourInARow.vue?vue&type=script&lang=js&"
export * from "./FourInARow.vue?vue&type=script&lang=js&"
import style0 from "./FourInARow.vue?vue&type=style&index=0&id=2c93f8fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c93f8fa",
  null
  
)

export default component.exports